export enum LANG_KEY {
  RU = 'ru',
  KZ = 'kk',
  AR = 'ar',
  EN = 'en',
}